import { useSelector } from 'react-redux';

import { ROLE } from '@/shared/api/borrow';
import { Store } from '@/shared/store';

export const useAgreementData = (role: string) => {
    return useSelector((state: Store) => {
        const isLender = role === ROLE.LENDER;

        return {
            tokens: state.tokens.agreementTokens,
            agreements: isLender
                ? state.agreements.lenderAgreements
                : state.agreements.borrowerAgreements,
            type: state.wallets.active.type,
        };
    });
};
